import { useMemo } from "react";
import { useUsers } from "./useUsers";

export function useUserData() {
  const { data: users, isError, error, refetch, isLoading } = useUsers();

  const errorMessage = useMemo(() => {
    return isError && error ? error.message : "";
  }, [isError, error]);

  return { users, isError, errorMessage, refetch, isLoading };
}
